import { Autocomplete, AutocompleteProps } from "@mantine/core";
import React from "react";

type McAutocompleteProps = Omit<AutocompleteProps, "onBlur"> & {
  onCommit?: (nextValue: string) => void | Promise<void>;
  onBlur?: (value: string) => void;
};

export function McAutocomplete({ onCommit, ...props }: McAutocompleteProps) {
  const ref = React.useRef<HTMLInputElement>(null);
  const [value, setValue] = React.useState<string>(props.value ?? "");

  return (
    <Autocomplete
      {...props}
      ref={ref}
      onClear={() => {
        ref.current?.blur();
        props.onClear?.();
      }}
      onBlur={(e) => {
        props.onBlur?.(e.currentTarget.value);
      }}
      onChange={(e) => {
        setValue(e);
      }}
      value={value}
      onOptionSubmit={(optionValue) => {
        onCommit?.(optionValue);
        ref.current?.blur();
      }}
      onKeyPress={(e) => {
        if (e.key === "Enter") {
          onCommit?.(e.currentTarget.value);
          ref.current?.blur();
          return;
        }
      }}
    />
  );
}
